import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faUserMd,
  faUsers,
  faHospital,
  faClinicMedical,
  faHospitals,
  faBolt,
  faBoxesStacked,
  faFlask,
  faMortarPestle,
} from '@fortawesome/pro-solid-svg-icons';
import { SizeProp, Styles } from '@fortawesome/fontawesome-svg-core';
import { SOC_TYPE_LABELS } from 'src/components/Profiles/components/ProfileDetails/socTypes';

interface TypeIconProps {
  type: string;
  size?: SizeProp;
  style?: Styles;
  color?: string;
  className?: string;
}

const iconMap = {
  activity: faBolt,
  hcp: faUserMd,
  hcp_group: faUsers,
  center: faHospital,
  clinic: faClinicMedical,
  system: faHospitals,
  office_clinic: faClinicMedical,
  asc: faClinicMedical,
  urgent_care: faClinicMedical,
  home_health: faClinicMedical,
  dme_supplier: faBoxesStacked,
  laboratory: faFlask,
  pharmacy: faMortarPestle,
};

const normalizeIconKey = (value?: string | null) =>
  value
    ?.toString()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const getSocTypeIcon = (socType?: string | null) => {
  if (!socType) return faHospital;
  return iconMap[normalizeIconKey(socType)] || faHospital;
};

const TypeIcon = ({
  type,
  size = null,
  style = null,
  color = null,
  className = '',
}: TypeIconProps) => {
  const normalized = normalizeIconKey(type);

  const isSiteOfCareType =
    normalized === 'site_of_care' ||
    (normalized && normalized in SOC_TYPE_LABELS);

  const fallback = isSiteOfCareType ? faHospital : faUserMd;

  return (
    <Icon
      icon={iconMap[normalized] || fallback}
      size={size}
      style={style || { width: '1.25rem' }}
      color={color}
      className={className}
    />
  );
};

export default TypeIcon;
